import { CurrencyUnit } from 'common/ShefPromoUtilities';
import { urlDateFormat } from 'common/UrlDate';
import { DateTime } from 'luxon';
import { PopoverPosition } from 'react-tiny-popover';

export const TEXT = {};

export const INITIAL_STATE = {
  isExplorePagePromo: true,
  isPercentage: true,
  maxUsesPerUser: 1,
  startDate: DateTime.local().toFormat(urlDateFormat),
  unit: CurrencyUnit.MAJOR,
  value: 15,
} as const;

export const VALUE_DROPDOWN_ITEMS = {
  EXACT_AMOUNT: {
    value: '$',
  },
  PERCENT: {
    value: '%',
  },
};

export const INPUT_LABELS = {
  CREATE_BUTTON: 'Create Promo Code',
  END_DATE: 'End Date',
  MAX_USES: 'Max Uses (Total)',
  MAX_USES_PER_USERS: 'Max Uses (Per User)',
  MIN_ORDER_VALUE: 'Minimum Order Value',
  NOTE: 'Note: this promo will apply to your entire menu',
  PROMO_CODE: 'Promo Code: ',
  START_DATE: 'Start Date',
  VALUE: 'Promo Code Value',
} as const;

export const POPUP_DEFAULTS = {
  // eslint-disable-next-line @typescript-eslint/consistent-type-assertions -- Set default value
  positions: ['bottom', 'top'] as PopoverPosition[],
};
